import { ApiError } from '../../../shared/models';

export const handleEditUserError = (
  error: unknown,
  setFieldError: (field: string, message: string | undefined) => void,
  showErrorToast: (error: string | ApiError) => string
) => {
  if (error instanceof ApiError && error.code === '02002') {
    setFieldError('email', 'A user with that email already exists');
  } else if (error instanceof ApiError && error.code === '02004') {
    setFieldError('mobileNumber', 'Invalid mobile phone number');
  } else {
    showErrorToast('Unable to edit user. Please try again.');
  }
};
